import { render, staticRenderFns } from "./checkout-items-list.vue?vue&type=template&id=c38b99d8&"
import script from "./checkout-items-list.vue?vue&type=script&lang=js&"
export * from "./checkout-items-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c38b99d8')) {
      api.createRecord('c38b99d8', component.options)
    } else {
      api.reload('c38b99d8', component.options)
    }
    module.hot.accept("./checkout-items-list.vue?vue&type=template&id=c38b99d8&", function () {
      api.rerender('c38b99d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/checkout-items-list/checkout-items-list.vue"
export default component.exports